export const sides = {
    FRONT:"front",
    BACK:"back",
    LEFT:"left",
    RIGHT:"right",
    LEFT_LONG:"left_long",
    RIGHT_LONG:"right_long"
};
